<template>
	<div class="bottom-wrapper">
		<div class="bottom-layer-one">
			<div
				v-visible="penalties[homeTeamId][0]"
				class="penalty-timer"
			>
				<span>{{ penalties[homeTeamId][0] }}</span>
			</div>
			<div
				v-visible="penalties[homeTeamId][1]"
				class="penalty-timer"
			>
				<span>{{ penalties[homeTeamId][1] }}</span>
			</div>
			<!-- time start/stop button -->
			<button
				v-if="!isTimeEditable || currentFormattedTime === timeInputValue"
				class="action-button"
				:class="{white: timeToggleButtonIcon === 'button-play-filled'}"
				:disabled="hasUpcomingClockStart"
				@click="$emit('handle-clock-toggle')"
			>
				<Icon
					:icon-name="timeToggleButtonIcon"
					size="sm"
				/>
			</button>
			<button
				v-else
				class="action-button"
				@click="$emit('save-time')"
			>
				<Icon
					icon-name="floppy-disk"
					size="md"
				/>
			</button>
			<div
				v-visible="penalties[guestTeamId][1]"
				class="penalty-timer"
			>
				<span>{{ penalties[guestTeamId][1] }}</span>
			</div>
			<div
				v-visible="penalties[guestTeamId][0]"
				class="penalty-timer"
			>
				<span>{{ penalties[guestTeamId][0] }}</span>
			</div>
		</div>
		<div class="bottom-layer-two">
			<div
				v-visible="penalties[homeTeamId][2]"
				class="penalty-timer grayed"
			>
				<span>{{ penalties[homeTeamId][2] }}</span>
			</div>
			<TagButton
				class="latest-tags-button"
				:label="$I18n.trans('one.latest_tags')"
				hide-icon
				:clickable="true"
				@click="$emit('open-latest-tags')"
			/>
			<div
				v-visible="penalties[guestTeamId][2]"
				class="penalty-timer  grayed"
			>
				<span>{{ penalties[guestTeamId][2] }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import TagButton from '@videotools/js/one/components/TagButton/TagButton';

export default {
	components: { TagButton },
	props:      {
		penalties: {
			type: Object,
		},
		homeTeamId: {
			type: Number,
		},
		guestTeamId: {
			type: Number,
		},
		isTimeEditable: {
			type: Boolean,
		},
		currentFormattedTime: {
			type: String,
		},
		timeInputValue: {
			type: String,
		},
		hasUpcomingClockStart: {
			type: Boolean,
		},
		timeToggleButtonIcon: {
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@videotools/sass/fonts';

.bottom-wrapper {
	display: flex;
	flex-direction: column;
}

.latest-tags-button {
	margin-top: 16px;
}

.bottom-layer-two {
	.penalty-timer {
		margin-top: 16px;
	}
}

.action-button:hover {
	background: var(--color-grey-750);
}
.action-button.white {
	color: white;
	border-color: white;
}

.penalty-timer {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 76px;
	height: 48px;
	border: 1px solid var(--color-grey-700);
	border-radius: 2px;

	&.grayed {
		color: var(--color-grey-700);
	}

	span {
		@include text-md-2;
	}
}
</style>
